// Generated by scripts/fetch-laws.ts from lawsofux.com and timsommer.be. Do not edit directly.
import type { Law } from "../types";

export const wirthsLaw: Law = {
  slug: "wirths-law",
  title: "Wirth's law",
  definition: "Software gets slower faster than hardware gets faster.",
  category: "theory",
  color: "#009084",
  labels: ["cs","software-engineering"],
  copy: ["Take that Moore's Law!"],
  sources: ["https://www.timsommer.be/famous-laws-of-software-development/"],
  related: [],
};
